














import { computed, defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'CarouselArrowButton',
  props: {
    isHorizontal: {
      type: Boolean,
      required: true,
    },
    isClickable: {
      type: Boolean,
      required: true,
    },
    isPreviousButton: {
      type: Boolean,
      required: true,
    },
  },
  setup(props) {
    const dynamicButtonClasses = computed(() => {
      return {
        'rounded-t-md': !props.isHorizontal && props.isPreviousButton,
        'rounded-b-md': !props.isHorizontal && !props.isPreviousButton,
        'rounded-l-md': props.isHorizontal && props.isPreviousButton,
        'rounded-r-md': props.isHorizontal && !props.isPreviousButton,
        'h-full': props.isHorizontal,
        'w-full': !props.isHorizontal,
        'cursor-not-allowed': !props.isClickable,
      };
    });
    const dynamicArrowClasses = computed(() => {
      return {
        'rotate-180': props.isHorizontal && props.isPreviousButton,
        '-rotate-90': !props.isHorizontal && props.isPreviousButton,
        'rotate-90': !props.isHorizontal && !props.isPreviousButton,
      };
    });
    const ariaLabel = computed(() => props.isPreviousButton ? 'Previous' : 'Next');

    return {
      dynamicButtonClasses,
      dynamicArrowClasses,
      ariaLabel,
    };
  },
});
